const stylesGlobal = {
  heroContainer: {
    position: "relative",
    width: "100%",
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
    backgroundColor: "#000",
  },

  background: {
    position: "absolute",
    top: 0,
    left: "clamp(-6rem, -8vw, -11rem)",
    width: "100%",
    height: "100%",
    objectFit: "cover",
    opacity: 0.6,
    zIndex: 1,
  },
};

export default stylesGlobal;
